module.exports = __webpack_public_path__ + "static/media/cw.69f19c22.svg";